const sessionTypeSelector = (state: any) => state.app.sessionType

export default sessionTypeSelector
